import { css } from "@emotion/core";

export const digitalCoursesPageStyle = css`
  .mobile-width {
    width: 100%;
  }
  .desktop-width {
    width: 20.9375em;
  }
`;
